<template>
  <section class="process">
    <div class="process__header">
      <h2 class="wd-title"><span class="process__base">Así</span> <span class="hl">avanza tu proceso</span></h2>
      <p class="wd-body">Tu camino está dividido en etapas claras. Aquí puedes entender en cuál estás y qué sigue:</p>
    </div>

    <div class="process__cards">
      <article
        v-for="(stage, index) in stages"
        :key="stage.number"
        class="wd-card process__card"
        :class="{ 'process__card--current': stage.number === activeStage }"
      >
        <span v-if="stage.number === activeStage" class="wd-tag-success">Etapa actual</span>
        <div class="process__stage">
          <span class="process__number">{{ stage.number }}</span>
          <div class="process__copy">
            <p class="process__title" :class="{ 'process__title--dark': index > 1 }">{{ stage.title }}</p>
            <p class="process__subtitle">{{ stage.subtitle }}</p>
          </div>
        </div>
        <p class="wd-body">{{ stage.description }}</p>
      </article>
    </div>
  </section>
</template>

<script setup lang="ts">
defineProps<{ activeStage?: number }>()
const stages = [
  {
    number: 1,
    title: 'Contratación',
    subtitle: 'Inicias tu camino',
    description:
      'Registramos tu solicitud y comenzamos con la revisión inicial de tu expediente para validar la información.'
  },
  {
    number: 2,
    title: 'Asesoria',
    subtitle: 'Avanzas con acompañamiento',
    description: 'Te orientamos y damos seguimiento para que conozcas los siguientes pasos y avances con claridad.'
  },
  {
    number: 3,
    title: 'Adjudicación',
    subtitle: 'Obtienes tu financiamiento',
    description:
      'Validamos tus requisitos para que puedas obtener la adjudicación de tu financiamiento y avanzar hacia tu inmueble.'
  },
  {
    number: 4,
    title: 'Escrituración',
    subtitle: 'Formalizas tu inmueble',
    description:
      'Integramos tu documentación y coordinamos la firma de tu escritura para formalizar la adquisición de tu inmueble.'
  },
  {
    number: 5,
    title: 'Liquidación',
    subtitle: 'Concluyes y recuperas tu garantía',
    description: 'Concluyes tus pagos y realizamos las gestiones necesarias para liberar y recuperar tu garantía.'
  }
]
</script>

<style scoped>
.process {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-5);
  padding: var(--ds-space-5);
  box-sizing: border-box;
  background: var(--ds-grey-50);
  border-radius: 16px;
}
.process__header {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-3);
}
.process__base {
  color: var(--ds-secondary-main);
}
.process__cards {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-4);
}
.process__card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--ds-space-4);
}
.process__card--current {
  border-color: var(--ds-purple-500);
}
.process__stage {
  display: flex;
  align-items: center;
  gap: var(--ds-space-4);
  width: 100%;
  min-height: 52px;
}
.process__number {
  display: flex;
  flex: 0 0 48px;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 47px;
  background: var(--ds-stage-number-bg);
  color: var(--ds-text-body);
  font-family: var(--ds-font-family-bebas);
  font-size: 24px;
  font-weight: 700;
}
.process__copy {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-3);
  min-width: 0;
}
.process__title,
.process__subtitle {
  margin: 0;
}
.process__title {
  color: var(--ds-secondary-main);
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
}
.process__title--dark {
  color: var(--ds-purple-900);
}
.process__subtitle {
  color: var(--ds-purple-500);
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
}

@media (min-width: 600px) and (max-width: 1024px) {
  .process {
    padding: var(--ds-space-5) var(--ds-space-6);
  }
}

@media (max-width: 599px) {
  .process {
    padding: var(--ds-space-5) var(--ds-space-4);
  }
}
</style>
